import { spacing } from "@rentiohq/web-theme";
import styled from "styled-components";

export const InnerWrap = styled.div`
  min-height: 48px;
  margin-left: 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const HeaderWrap = styled.div`
  position: sticky;
  top: 0;
  background: ${({ theme }) => theme.colors.neutral0};
  z-index: 1;
  box-shadow: 0px 6px 6px -7px rgba(0, 0, 0, 0.65);
  -webkit-box-shadow: 0px 6px 6px -7px rgba(0, 0, 0, 0.65);
  -moz-box-shadow: 0px 6px 6px -7px rgba(0, 0, 0, 0.65);
`;

export const HeaderInnerWrap = styled.div`
  margin-left: 24px;
  min-height: 32px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const PropertyListItemItem = styled.div`
  word-break: break-all;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const PropertyListItemSpacer = styled.div`
  background-color: ${props => props.theme.colors.global3};
  align-self: stretch;
  width: 1px;
  margin: 0 12px;
`;

export type Alignment = "start" | "space-between" | "center" | "end";
export const ChildrenWrap = styled.div<{
  alignment?: Alignment;
}>`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: ${({ alignment }) => alignment ?? "space-between"};
  align-items: center;
  min-width: 0;
`;

export const RentStatusStack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`;

// Mirror the ForRentCell wrapper's left padding so the Rentmatch badge lines up
// vertically centered under the for-rent icon (both are centered by the same offset).
export const RentMatchBadgeWrapper = styled.div`
  padding-left: ${spacing("tight")};
`;

export const IconWrapper = styled.div<{ inGroup: boolean }>`
  display: flex;
  align-items: center;
  border: ${props =>
    props.inGroup ? `1px solid ${props.theme.getColor("gray", 400)}` : "none"};
  border-radius: 4px;
`;

export const Icon = styled.div`
  margin-left: 0px;
`;
